<template>
  <div>
    <v-dialog v-model="dialogDetail" width="500">
      <v-card>
        <v-card-title class="headline grey lighten-2">
          รายการข้อมูลประจำวันที่ ..... ภาค .....
        </v-card-title>

        <v-row>
          <v-col
            class="text-center Formmat"
            lg="12"
            sm="12"
            md="12"
            cols="12"
            xl="12"
            xs="12"
          >
            <v-card class="mx-auto" max-width="100%" height="100%">
              <v-container fluid>
                <v-row
                  justify="center"
                  align="center"
                  v-for="(item, index) in itemss"
                  :key="index"
                >
                  <v-card
                    class="mx-auto"
                    color="#26c6da"
                    max-width="100%"
                    height="100%"
                    dark
                  >
                    <v-card-title>
                      <v-icon large left> mdi-twitter </v-icon>
                      <span class="title font-weight-light"
                        >จังหวัด {{ item.provincesname }}</span
                      >
                    </v-card-title>

                    <v-card-text class="headline font-weight-bold">
                      จำนวน {{ item.countproject }} รายการ
                    </v-card-text>

                    <v-card-actions>
                      <v-list-item class="grow">
                        <v-list-item-avatar color="grey darken-3">
                          <v-img
                            class="elevation-6"
                            alt=""
                            src="https://avataaars.io/?avatarStyle=Transparent&topType=ShortHairShortCurly&accessoriesType=Prescription02&hairColor=Black&facialHairType=Blank&clotheType=Hoodie&clotheColor=White&eyeType=Default&eyebrowType=DefaultNatural&mouthType=Default&skinColor=Light"
                          ></v-img>
                        </v-list-item-avatar>

                        <v-list-item-content>
                          <v-list-item-title>Evan You</v-list-item-title>
                        </v-list-item-content>

                        <v-row align="center" justify="end">
                          <v-icon class="mr-1"> mdi-heart </v-icon>
                          <span class="subheading mr-2">256</span>
                          <span class="mr-1">·</span>
                          <v-icon class="mr-1"> mdi-share-variant </v-icon>
                          <span class="subheading">45</span>
                        </v-row>
                      </v-list-item>
                    </v-card-actions>
                  </v-card>
                </v-row>
              </v-container>
            </v-card>
          </v-col>
        </v-row>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="dialog = false"> I accept </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-container fluid>
      <v-row justify="center" align="center">
        <v-col class="text-center" lg="2" sm="2" md="2" cols="2" xl="2" xs="2">
          <v-card class="mx-auto" max-width="100%">
            <v-img
              class="white--text align-end"
              height="200px"
              src="../assets/2.ภาคใต้.jpg"
            >
              <b style="font-size: 30px">{{ countGeographySouth }} โครงการ</b>
            </v-img>
          </v-card>
        </v-col>
        <v-col class="text-center" lg="2" sm="2" md="2" cols="2" xl="2" xs="2">
          <v-card class="mx-auto" max-width="100%">
            <v-img
              class="white--text align-end"
              height="200px"
              src="../assets/3ภาคกลาง.jpg"
            >
              <b style="font-size: 30px">{{ countGeographyCentral }} โครงการ</b>
            </v-img>
          </v-card> </v-col
        ><v-col class="text-center" lg="2" sm="2" md="2" cols="2" xl="2" xs="2">
          <v-card class="mx-auto" max-width="100%">
            <v-img
              class="white--text align-end"
              height="200px"
              src="../assets/5.ภาคเหนือ.jpg"
            >
              <b style="font-size: 30px"
                >{{ countGeographyNortheast }} โครงการ</b
              >
            </v-img>
          </v-card> </v-col
        ><v-col class="text-center" lg="2" sm="2" md="2" cols="2" xl="2" xs="2">
          <v-card class="mx-auto" max-width="100%">
            <v-img
              class="white--text align-end"
              height="200px"
              src="../assets/4ตะวันตก.jpg"
            >
              <b style="font-size: 30px">{{ countGeographyWest }} โครงการ</b>
            </v-img>
          </v-card> </v-col
        ><v-col class="text-center" lg="2" sm="2" md="2" cols="2" xl="2" xs="2">
          <v-card class="mx-auto" max-width="100%">
            <v-img
              class="white--text align-end"
              height="200px"
              src="../assets/ตะวันออก.jpg"
            >
              <b style="font-size: 30px">{{ countGeographyEast }} โครงการ</b>
            </v-img>
          </v-card> </v-col
        ><v-col class="text-center" lg="2" sm="2" md="2" cols="2" xl="2" xs="2">
          <v-card class="mx-auto" max-width="100%">
            <v-img
              class="white--text align-end"
              height="200px"
              src="../assets/6.ภาคเหนือ.jpg"
            >
              <b style="font-size: 30px">{{ countGeographyNorth }} โครงการ</b>
            </v-img>
          </v-card>
        </v-col>
      </v-row>
      <v-row justify="center" align="start">
        <v-col class="text-center Format" cols="8" sm="8" md="8">
          <v-card class="mx-auto" max-width="100%" height="100%">
            <v-container fluid>
              <v-row justify="center" align="center">
                <v-col cols="3" sm="3" md="3">
                  <v-icon left light style="color: #000"
                    >mdi-calendar-range</v-icon
                  >
                  <b>วันที่ตรวจสอบ</b>
                </v-col>
                <v-col cols="3" sm="3" md="3">
                  <v-icon left light style="color: #000"
                    >mdi-electron-framework</v-icon
                  >
                  <b>ประเภทประกาศ</b>
                </v-col>
                <v-col cols="3" sm="3" md="3">
                  <v-icon left light style="color: #000"
                    >mdi-map-marker-radius-outline</v-icon
                  >
                  <b>ภูมิภาค</b>
                </v-col>
              </v-row>
              <v-row justify="center" align="center">
                <v-col cols="3" sm="3" md="3">
                  <v-dialog
                    ref="dialog"
                    v-model="modal"
                    :return-value.sync="form.created_datetime"
                    persistent
                    width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        outlined
                        dense
                        v-model="form.created_datetime"
                        :rules="rules.day"
                        placeholder="กรุณาเลือกวันที่"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker v-model="form.created_datetime" scrollable>
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="modal = false">
                        Cancel
                      </v-btn>
                      <v-btn
                        text
                        color="primary"
                        @click="$refs.dialog.save(form.created_datetime)"
                      >
                        OK
                      </v-btn>
                    </v-date-picker>
                  </v-dialog>
                </v-col>

                <v-col cols="3" sm="3" style="padding-top: 15px">
                  <v-select
                    :items="categorys"
                    v-model="form.category"
                    :rules="rules.category"
                    placeholder="ประเภทประกาศ"
                    dense
                    outlined
                  ></v-select>
                </v-col>
                <v-col cols="3" sm="3" md="3" class="Format">
                  <v-autocomplete
                    :items="geographies"
                    v-model="form.geographie"
                    item-text="name"
                    item-value="id"
                    outlined
                    dense
                    placeholder="ภาค"
                  ></v-autocomplete>
                </v-col>
              </v-row>
              <v-row justify="center" align="center">
                <v-col
                  cols="2"
                  sm="2"
                  md="2"
                  style="
                    padding-left: 0px;
                    padding-top: 0px;
                    padding-right: 0px;
                    padding-bottom: 0px;
                  "
                >
                  <v-row align="center" justify="space-around">
                    <v-btn @click="getprovinces" tile color="success">
                      <v-icon left> mdi-magnify </v-icon>
                      ตรวจสอบข้อมูล
                    </v-btn>
                  </v-row>
                </v-col>
              </v-row>
              <v-row justify="center" align="center">
                
                <v-col cols="12" sm="6">
                  <v-hover v-slot="{ hover }" close-delay="200">
                    <v-card
                      :elevation="hover ? 16 : 2"
                      :class="{ 'on-hover': hover }"
                      class="mx-auto"
                      height="80%"
                      max-width="600"
                    >
                    
                    <v-col cols="12" sm="6">
                      <b>ประเภทประกาศ</b>
                      <v-select
                    :items="categorys"
                    v-model="egp.type"
                    :rules="rules.category"
                    placeholder="ประเภทประกาศ"
                    dense
                    outlined
                  ></v-select>
                    </v-col>
                    <v-col cols="12" sm="6">
                      <b>วันที่เช็คข้อมูล</b>
                  <v-dialog
                    ref="dialog2"
                    v-model="modal2"
                    :return-value.sync="egp.date"
                    persistent
                    width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        outlined
                        dense
                        v-model="egp.date"
                        :rules="rules.day"
                        placeholder="กรุณาเลือกวันที่"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker v-model="egp.date" scrollable>
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="modal2 = false">
                        Cancel
                      </v-btn>
                      <v-btn
                        text
                        color="primary"
                        @click="$refs.dialog2.save(egp.date)"
                      >
                        OK
                      </v-btn>
                    </v-date-picker>
                  </v-dialog>
                </v-col>
                      <v-col cols="12" sm="6">
                        <b>จังหวัด</b>
                        <v-autocomplete
                          :items="provinces"
                          v-model="egp.province"
                          item-text="name_th"
                          item-value="id"
                          outlined
                          dense
                          placeholder="จังหวัด"
                        ></v-autocomplete>
                      </v-col>
                      <v-col cols="12" sm="6">
                        <b>จำนวนงานจากภาครัฐ </b>
                        <v-text-field
                          dense
                          outlined
                          type="number"
                          v-model="egp.count"
                          class="mx-auto"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6">
                        <v-btn color="success" @click="inputCountEGP()">บันทึกจำนวนประกาศ</v-btn>
                      </v-col>
                    </v-card>
                  </v-hover>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-hover v-slot="{ hover }" close-delay="200">
                    <v-card
                      :elevation="hover ? 16 : 2"
                      :class="{ 'on-hover': hover }"
                      class="mx-auto"
                      height="80%"
                      max-width="600"
                    >
                      <v-col>
                        <b style="font-size: 30px"
                          >จำนวนงานที่ถูกเพิ่มเข้ามาในระบบจำนวน
                        </b>
                      </v-col>
                      <v-col>
                        <p v-for="(list,index) in listprovince" :key="index">
                          จังหวัด{{list.name_th}} {{list.count}}/{{list.count_egp}}
                        </p>
                      </v-col>
                    
                    </v-card>
                  </v-hover>
                </v-col>
              </v-row>
            </v-container>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      dialogDetail: false,
      numeral: 0,
      itemss: [],
      geographies: [],
      countproject: [],
      provinces: [],
      categorys: [{ text: "ประกาศร่างtor" }, { text: "ประกาศเชิญชวน" }],
      day: null,
      date: null,
      menu: null,
      modal: false,
      modal2: false,
      egp: {
        count: 0,
        province: null,
        type: "",
        date: null
      },
      recommendProject: null,
      countGeographyNorth: null, //ภาคเหนือ
      countGeographyCentral: null, //ภาคกลาง
      countGeographyNortheast: null, //ตะวันออกเฉียงเหนือ
      countGeographyWest: null, //ตะวันตก
      countGeographyEast: null, //ภาคตะวันออก
      countGeographySouth: null, //ภาคใต้
      countprojects: [],
      listprovince: [],
      form: {
        total: 0,
        inputgovernment: 0,
        geographie: null,
        category: "ประกาศเชิญชวน",
        created_datetime: null,
      },
      rules: {
        day: [(v) => !!v || "กรุณากรอกวันที่ค้นหาให้ถูกต้อง"],
        category: [(v) => !!v || "กรุณาเลือกประเภทที่ค้นหาให้ถูกต้อง"],
      },
    };
  },
  mounted() {
    axios.get(this.api + "/get/recommend/project").then((res) => {
      this.recommendProject = [];
      this.recommendProject = res.data.response;
    });

    axios.get(this.api + "/get/countproject").then((res) => {
      this.itemss = [];
      this.itemss = res.data.response;
    });

    axios.get(this.api + "/get/provinces").then((res) => {
      this.provinces = [];
      this.provinces = res.data.response;
    });

    axios.get(this.api + "/get/countGeography_North").then((res) => {
      this.countGeographyNorth = [];
      if (res.data.response[0] === undefined) {
        this.countGeographyNorth = 0;
      } else {
        this.countGeographyNorth = res.data.response[0].countproject;
      }
    });

    axios.get(this.api + "/get/countGeography_Central").then((res) => {
      this.countGeographyCentral = [];
      if (res.data.response[0] === undefined) {
        this.countGeographyCentral = 0;
      } else {
        this.countGeographyCentral = res.data.response[0].countproject;
      }
    });

    axios.get(this.api + "/get/countGeography_Northeast").then((res) => {
      this.countGeographyNortheast = [];
      if (res.data.response[0] === undefined) {
        this.countGeographyNortheast = 0;
      } else {
        this.countGeographyNortheast = res.data.response[0].countproject;
      }
    });

    axios.get(this.api + "/get/countGeography_West").then((res) => {
      this.countGeographyWest = [];
      if (res.data.response[0] === undefined) {
        this.countGeographyWest = 0;
      } else {
        this.countGeographyWest = res.data.response[0].countproject;
      }
    });

    axios.get(this.api + "/get/countGeography_East").then((res) => {
      this.countGeographyEast = [];
      if (res.data.response[0] === undefined) {
        this.countGeographyEast = 0;
      } else {
        this.countGeographyEast = res.data.response[0].countproject;
      }
    });

    axios.get(this.api + "/get/countGeography_South").then((res) => {
      this.countGeographySouth = [];
      if (res.data.response[0] === undefined) {
        this.countGeographySouth = 0;
      } else {
        this.countGeographySouth = res.data.response[0].countproject;
      }
    });
    axios.get(this.api + "/get/geographies").then((res) => {
      this.geographies = [];
      this.geographies = res.data.response;
    });
  },

  methods: {
    inputCountEGP(){
      this.egp.username = localStorage.getItem("username")
      axios.post(this.api + "/post/tor_check_egp",this.egp).then(res=>{
        if(res.data.status){
          location.reload();
        }
      })
    },
    getprovinces() {
      if (this.form.created_datetime === null) {
        alert("กรุณาเลือกวันที่ประกาศ");
      } else if (this.form.category === null) {
        alert("กรุณาเลือกประเภทประกาศ");
      } else {
        if (this.form.category === "ประกาศร่างtor") {
          this.form.category = "tor";
        } else {
          this.form.category = "invite";
        }
        if (this.form.province != null) {
          axios.post(this.api + "/get/count", this.form).then((res) => {
            this.listprovince = res.data.response;
          });
        } else {
          axios.post(this.api + "/get/count", this.form).then((res) => {
            this.listprovince = res.data.response;
          });
        }
      }
    },
  },
};
</script>
